/* cart-key-fix v2 — key-based cart item removal for Eurus xCart.
   Root cause: _postUpdateItem posts numeric line POSITION to /cart/change.js,
   but the delivery-estimate widget re-adds all items on every action, shuffling
   positions. Fix: rewrite the request to use the stable line-item KEY.
   Works across re-renders by wrapping the Alpine.data('xCart') factory, so
   every newly created component instance is patched. */
(function () {
  if (window.__cartKeyFixV2) return;
  window.__cartKeyFixV2 = true;

  // One global fetch shim: when a key is pending, rewrite the next
  // position-based /cart/change.js body to id(key)-based.
  var pendingKey = null;
  var realFetch = window.fetch;
  window.fetch = function (url, opts) {
    try {
      if (pendingKey !== null
          && typeof url === 'string'
          && url.indexOf('cart/change') > -1
          && opts && typeof opts.body === 'string') {
        var b = JSON.parse(opts.body);
        if ('line' in b) {
          delete b.line;
          b.id = String(pendingKey);
          opts.body = JSON.stringify(b);
          pendingKey = null;
        }
      }
    } catch (e) { /* never break checkout over a patch */ }
    return realFetch.apply(window, arguments);
  };

  // Registered directly (theme.js registers its listeners inside rAF,
  // so this listener runs first and wraps Alpine.data before xCart registers).
  document.addEventListener('alpine:init', function () {
    if (!window.Alpine || Alpine.__cartKeyFixV2) return;
    Alpine.__cartKeyFixV2 = true;

    var origData = Alpine.data.bind(Alpine);
    Alpine.data = function (name, factory) {
      if (name !== 'xCart') return origData(name, factory);
      return origData(name, function () {
        var comp = factory.apply(this, arguments);

        var origPost = comp._postUpdateItem;
        if (typeof origPost === 'function') {
          comp._postUpdateItem = function (itemId, line, qty, maxQty, wait, isShippingInsurance) {
            pendingKey = itemId; // itemId IS the line-item key in Eurus markup
            return origPost.call(this, itemId, line, qty, maxQty,
              wait === undefined ? 500 : wait, isShippingInsurance);
          };
        }

        var origUI = comp.updateCartUI;
        if (typeof origUI === 'function') {
          comp.updateCartUI = function (parsedState, sectionArray, itemId, line, qty) {
            var fixedLine = line;
            try {
              if (parsedState && Object.prototype.toString.call(parsedState.items) === '[object Array]') {
                var idx = -1;
                for (var i = 0; i < parsedState.items.length; i++) {
                  if (parsedState.items[i].key === itemId) { idx = i; break; }
                }
                fixedLine = idx > -1 ? idx + 1 : parsedState.items.length + 1;
              }
            } catch (e) {}
            return origUI.call(this, parsedState, sectionArray, itemId, fixedLine, qty);
          };
        }

        return comp;
      });
    };
  });
})();
